import React from "react";
import styled from "styled-components/macro";
import { toRem } from "theme/Breakpoints";
import { DefaultText } from "theme/GlobalElements";
import { colors } from "theme/Theme";

interface ServiceItemProps {
  text: string;
  icon: any;
}

const ServiceItem: React.FC<ServiceItemProps> = ({ text, icon }) => {
  return (
    <ServiceItemContainer>
      <Box>
        <SVGImg src={icon} />
      </Box>
      <Description className="text-sm">{text}</Description>
    </ServiceItemContainer>
  );
};

const ServiceItemContainer = styled.div`
  flex: 0 33%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;

  & + & {
    margin-left: 10px;
  }
`;

const Box = styled.div`
  display: flex;
  padding: 10px;
  background-color: white;
  border: 5px solid ${colors.gray};
  margin-bottom: 5px;
`;

const SVGImg = styled.img`
  width: 32px;
  height: 32px;
  filter: invert(46%) sepia(35%) saturate(7244%) hue-rotate(185deg) brightness(106%) contrast(104%);
`;

const Description = styled(DefaultText)`
  text-align: center;
  font-weight: 500;
`;

export default ServiceItem;
